export default {
  title: 'Trigger message when Offer becomes available',
  description:
    'Send a triggered marketing message to a member when this offer becomes visible to them',
};
